<template>
  <div class="grid-order-delete">
    <div v-if="loading" class="loader"></div>
    <div v-else>
      <div class="buttons-cnt">
        <button class="button" v-on:click="copyOrderNumbers">
          {{ $t('admin.copy_order_numbers') }}
        </button>
      </div>
      <ag-grid-vue
        :key="reloadGrid"
        class="ag-theme-balham"
        data-cy="grid-order-delete"
        :grid-options="gridOptions"
        :column-defs="columnDefinitions"
        :default-col-def="defaultColDef"
        :row-data="rowData"
        :pagination="true"
        :pagination-page-size="pageSize"
        :suppress-menu-hide="true"
        :modules="modules"
        v-on:first-data-rendered="onFirstDataRendered">
      </ag-grid-vue>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { GridApi } from '@ag-grid-community/core';
import { AgGridVue } from '@ag-grid-community/vue3';
import { OrdersService } from '@/services/orders.service';
import { ManuallyDeletableOrderDto } from '@onrunning/backstage-models';

export default defineComponent({
  name: 'grid-order-delete',
  components: {
    AgGridVue,
  },

  props: {
    reloadGrid: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      loading: false,
      ordersService: new OrdersService(),
      columnDefinitions: new Array<any>(),
      rowData: new Array<any>(),
      gridApi: undefined as GridApi | undefined,
      gridOptions: {
        domLayout: 'autoHeight',
        enableCellTextSelection: 'true',
        rowHeight: 40,
      } as any,
      modules: [ClientSideRowModelModule],
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
      },
      pageSize: 20,
      rowPixelsOffset: 1,
    };
  },
  async mounted() {
    const orderDeleteValidation = await this.ordersService.getDeletableOrders();

    this.loading = false;

    if (orderDeleteValidation.model) {
      this.loadDeletableOrdersGrid(orderDeleteValidation.model);
    }

    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    this.gridApi = undefined;
  },
  methods: {
    loadDeletableOrdersGrid(deletableOrders: ManuallyDeletableOrderDto[]) {
      const columnDefinitions = [
        {
          headerValueGetter: () => this.$t('viewOrders.items_list_columns.order_number'),
          field: 'orderNumber',
          width: '70px',
          cellStyle: { textAlign: 'left' },
        },
        {
          headerValueGetter: () => this.$t('viewOrders.orders_list_columns.order_status'),
          field: 'status',
          width: '100px',
          cellStyle: { textAlign: 'left' },
        },
        {
          headerValueGetter: () => this.$t('viewOrders.orders_list_columns.created_at'),
          field: 'createdAt',
          width: '100px',
          cellStyle: { textAlign: 'left' },
        },
      ];

      this.columnDefinitions = columnDefinitions;
      this.rowData = deletableOrders;
    },
    onFirstDataRendered(params: any) {
      this.gridApi = params.api;
      params.api.sizeColumnsToFit();
    },
    handleResize() {
      this.gridApi?.sizeColumnsToFit();
    },
    copyOrderNumbers() {
      let orderNumbers = '';

      this.gridApi?.forEachNodeAfterFilter((node) => {
        orderNumbers += `${node.data.orderNumber},`;
      });

      navigator.clipboard.writeText(orderNumbers);
    },
  },
});
</script>

<style lang="scss" scoped>
.grid-order-delete {
  .buttons-cnt {
    padding: 10px 0 30px;
    text-align: right;
  }
}
</style>
